<template>
	<div class="h100">
        <div class="flex h100" style="">
            <div style="width:50%">
                <div class="fs13 flex mb5">调出项目<div style="color:red">*</div></div>
                <a-select
                    show-search
                    v-model="newTransport.data.project_id"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    style="width: 300px"
                    placeholder="请选择调出项目"
                    @change="updateSelectProject(1)"
                    size="small"
                > 
                <a-select-option v-for="item in (projectList.filter(it=>it.id != this.newTransport.data.to_project_id))" :key="item.id" :value="item.id">
                    {{ item.name }} —— {{ item.create_time.substring(0,10)}}
                    </a-select-option>
                </a-select>
            </div>
            <div>
                <div class="fs13 flex mb5">调入项目<div style="color:red">*</div></div>
                <a-select
                    show-search
                    v-model="newTransport.data.to_project_id"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    style="width: 300px"
                    placeholder="请选择调入项目"
                    @change="updateSelectProject(2)"
                    size="small"
                > 
                <a-select-option v-for="item in (projectList.filter(it=>it.id != this.newTransport.data.project_id))" :key="item.id" :value="item.id">
                    {{ item.name }} —— {{ item.create_time.substring(0,10)}}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        
        <div class="flex mt10">
            <div style="width:50%">
                <div class="fs13 mb5">备注</div>
                <a-textarea
                    v-model="newTransport.data.note"
                    placeholder="请输入备注"
                    style="width:80%"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                />
            </div>
            <div>
                <div class="fs13 mb5">附件</div>
                <div class="clearfix">
                    <a-upload
                        :action="upload_url"
                        :headers="headers"
                        list-type="picture"
                        @change="handleChange"
                    >
                        <a-button> <a-icon type="upload" /> 上传附件 </a-button>
                    </a-upload>
                </div>
            </div>
        </div>
        <a-table class="mt20" :columns="materialColumns" :data-source="newTransport.data.materials" bordered size="small">
            <template slot="action" slot-scope="text, record, index">
                <div class="flex" style="justify-content: space-between;">
                    <a-icon type="plus"  @click="addMaterial"/>
                    <a-icon type="minus" @click="deleteMaterial(record.key)"/>
                </div>
            </template>
            <template
                v-for="col in ['name', 'count']"
                :slot="col"
                slot-scope="text, record, index"
            >
            <div>
                <div>
                    <a-input-number
                        v-if="col == 'count'"
                        style="margin: -5px 0"
                        v-model="record.count"
                        :min="0" 
                        :max="record.current_count"
                        size="small"
                    />
                    <a-select
                        v-if="col == 'name'"
                        show-search
                        style="width: 100%;"
                        v-model="record.id"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        placeholder="请选择物资"
                        @change="updateMaterialSelect(record)"
                        size="small"
                    > 
                        <a-select-option v-for="item1 in outMaterialList" :key="item1.key" :value="item1.id">
                            {{ item1.name }} 
                        </a-select-option>
                    </a-select>
                </div>
            </div>
            </template>
        </a-table>
	</div>
</template>

<script>
const KF = 'updatable';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
	export default ({
        props:{
            material:{
                type: Object,
            }
        },
		components: {

		},
		data() {
			return {
                form: this.$form.createForm(this),
				data:[],
                materialColumns:[
                    {
                        title: '',
                        dataIndex: 'action',
                        key: 'action',
                        width:'5%',
                        scopedSlots: { customRender: 'action' },
                    },
                    {
                        title: '序号',
                        dataIndex: 'key',
                        key: 'key',
                        width:'5%',
                    },
                    {
                        title: '物资名称',
                        dataIndex: 'name',
                        key: 'name',
                        width:'15%',
                        scopedSlots: { customRender: 'name' },
                    },
                    {
                        title: '物资规格',
                        dataIndex: 'size',
                        key: 'size',
                        ellipsis: true,
                    },
                    {
                        title: '物资单位',
                        dataIndex: 'unit',
                        key: 'unit',
                        width:'10%',
                    },
                    {
                        title: '调运数量',
                        dataIndex: 'count',
                        key: 'count',
                        width:'10%',
                        scopedSlots: { customRender: 'count' },
                    },
                ],
				page:{page:1,total:0},
				newTransport:{event_type:33,note:"", data:{attachment:[], }, flowdata:[]},
                projectList:[],
                outMaterialList:[],
                selectCondition:0,  //1 审批人1 3 审批人2 
                visible: false,
                confirmLoading: false,
                checkedKeysList:[],
                checkedKeys:[],
                upload_url: "",
				headers: {},
                editingKey:false,
                previewVisible: false,
                previewImage: '',
                obviousRecord: false,
                formItemLayout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 18 },
                },

			}
		},
        onshow(){

        },
		created(){
            this.upload_url = this.$api.request_body.url + "/project/upload_assets";
			this.headers.token = this.$api.request_body.token;

		},
		methods:{
            async getProjectList(){
                let rs = await this.$api.getProjectList()
                if(rs.err == 0){
                    this.projectList = rs.data
                }
            },
            async getOutMaterialList(){
                let rs = await this.$api.getProjectMaterialList(this.newTransport.data.project_id)
                if(rs.err == 0){
                    this.outMaterialList = rs.data
                }
            },
			addTransport(){
                let aa = {}
                aa.id = 0
                aa.project_id = this.material.project_id, 
                aa.from_project_name = this.material.project_name,
                aa.to_project_id = null, 
                aa.to_project_name = ""
                aa.materials = [{id:this.material.material_id, key: 1,name:this.material.name, size:this.material.size, unit:this.material.unit, count:0, current_count:this.material.current_count}],
                aa.attachment = []
                aa.note = ""
            
                this.newTransport.data = aa
                this.newTransport.event_type = 33
                this.newTransport.note = ""

                this.newTransport.flowdata = []

				this.visibleAddPlan = true;
                this.getProjectList()
                this.getOutMaterialList()
			},
      
            check(){
                if(this.newTransport.data.project_id ==null){
                    this.$notification['warning']({
                        message: '请选择调出项目',
                        style: {
                            width: '600px',
                            marginLeft: `${335 - 600}px`,
                        },
                    });
                    return;
                }
                if(this.newTransport.data.to_project_id == null){
                    this.$notification['warning']({
                        message: '请选择调入项目',
                        style: {
                            width: '600px',
                            marginLeft: `${335 - 600}px`,
                        },
                    });
                    return;
                }
                let part = this.newTransport.data.materials.find(it=>((it.id == null)||(it.count == null)||(it.count == 0)))
                if(part != null){
                    if(part.id == null){
                        this.$notification['warning']({
                            message: '请选择物资',
                            style: {
                                width: '600px',
                                marginLeft: `${335 - 600}px`,
                            },
                        });
                        return;
                    }else if ((part.count == null)||(part.count == 0)){
                        this.$notification['warning']({
                            message: '请填写物资数量',
                            style: {
                                width: '600px',
                                marginLeft: `${335 - 600}px`,
                            },
                        });
                        return;
                    }
                }

                return true;
            },
			onClose(){
                this.visibleAddPlan = false
                this.visibleCheckTransport = false
                this.visibleCheckData = false
			},
            updateSelectProject(key){
                if(key == 1){
                    let item = this.projectList.find(it=>it.id == key)
                    if(item != null){
                        this.newTransport.data.from_project_name = item.name
                    }
                    this.newTransport.data.materials = [{id:null, key:1,name:"", size:"", unit:"", count:null}]
                    this.getOutMaterialList()
                }else if(key ==2){
                    let item = this.projectList.find(it=>it.id == key)
                    if(item != null){
                        this.newTransport.data.to_project_name = item.name
                    }
                }
            },
            updateMaterialSelect(item){
                let item1 = this.outMaterialList.find(it=> it.id == item.id)
                if(item1 != null){

                    item.id = item1.id
                    item.name = item1.name
                    item.size = item1.size
                    item.unit = item1.unit
                    item.count = 0
                    item.current_count = item1.current_count
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            deleteMaterial(key){
                this.newTransport.data.materials = this.newTransport.data.materials.filter(it=>it.key != key)
                let nm = 1
                for(let item of this.newTransport.data.materials){
                    item.key = nm
                    nm++
                }

            },
            openTransportData(){
                this.visibleCheckData = true
            },
            beforeUpload(file) {
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				if (!isJpgOrPng) {
					this.$message.error('只能上传PNG/JPEG');
				}
				return isJpgOrPng;
			},
            handleChange(info) {
				const status = info.file.status;
				if (info.file.status === 'uploading') {
					this.uploading = true;
					return;
				}
				if (status !== 'uploading') {
				}
				if (status === 'done') {
					if (info.file.response.err == 0) {
                        this.newTransport.data.attachment = []
                        for(let part of info.fileList){
                            this.newTransport.data.attachment.push(part.response.data);
                        }
						this.$message.success(`${info.file.name} 上传成功`);
					} else {
						this.$message.error(`${info.file.name} 上传失败`);
					}
					this.uploading = false
				} else if (status === 'error') {
				}
			},
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            downImg(item){
                window.location.href = item;
            },
            allowCostClear(){
                if(this.search.length == 0){
                    this.page.page = 1;
					this.getTransportApplyRecord()
                }
            },  
            addMaterial(){
                let as = {id:null, key: this.newTransport.data.materials.length + 1,name:"", size:"", unit:"", count:0, editable:true}
                this.newTransport.data.materials.push(as)
                this.cacheData = this.newTransport.data.materials.map(item => ({ ...item }));
            },
            edit(key) {
                const newData = [...this.newTransport.data.materials];
                const target = newData.find(item => key === item.key);
                this.editingKey = key;
                if (target) {
                    target.editable = true;
                    this.newTransport.data.materials = newData;
                }
            },
            save(key) {
                const newData = [...this.newTransport.data.materials];
                const newCacheData = [...this.cacheData];
                const target = newData.find(item => item.key === key);
                const targetCache = newCacheData.find(item => item.key === key);
                console.log(target)
                console.log(targetCache)

                if (target && targetCache) {
                    delete target.editable;
                    this.newTransport.data.materials = newData;
                    Object.assign(targetCache, target);
                    this.cacheData = newCacheData;
                }
                this.editingKey = '';
            },
            cancel(key) {
                const newData = [...this.newTransport.data.materials];
                const target = newData.find(item => key === item.key);
                this.editingKey = '';
                if (target) {
                    Object.assign(target, this.cacheData.find(item => key === item.key));
                    delete target.editable;
                    this.newTransport.data.materials = newData;
                }
            },

		}
	})

</script>

<style lang="scss">
	.picture-container {
	  display: grid;
	  grid-template-columns: repeat(4, 1fr);
	  grid-gap: 10px; /* Optional: add some spacing between the images */
	}
	
	.picture-container img {
	  max-width: 100%;
	  height: auto;
	}
    .modal-wrapper {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow: auto;
        max-height: 90vh;
        width: 90%;
        max-width: 1500px;
        background-color: #ffffff;
        padding: 20px;
    }
</style>